import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreRoutingModule } from './core-routing.module';
import {RouterModule} from '@angular/router';
import {HeaderComponent} from './header/header.component';
import {SharedModule} from '../shared/shared.module';
import {FooterComponent} from './footer/footer.component';
import {SessionService} from './services/sessionService';
import {AuthenticationService} from './services/authentication.service';
import {AuthGuardService} from './services/auth-guard.service';
import {CookieService} from 'angular2-cookie/core';
import {SafeguardService} from './services/safeguard.service';

@NgModule({
  imports: [
    CommonModule,
    CoreRoutingModule,
    SharedModule
  ],
  declarations: [HeaderComponent, FooterComponent],
  exports: [
    RouterModule,
    HeaderComponent,
    FooterComponent],
    providers: [ SessionService, AuthenticationService, AuthGuardService, CookieService, SafeguardService ]
})
export class CoreModule { }



// WEBPACK FOOTER //
// ./src/app/core/core.module.ts